/* ==========================================================================
   DM WhatsApp Chat Widget
   - Toggle on click
   - Auto-open after delay (optional, respects localStorage closed flag)
   - Quick replies open WhatsApp with custom message
   - Escape closes the box
   ========================================================================== */
(function () {
  'use strict';

  // Guard: prevent double-init when section reloads in editor
  if (window.__dmWhatsAppReady) return;
  window.__dmWhatsAppReady = true;

  var STORAGE_KEY = 'dm-wa-closed';

  function safeGetClosed() {
    try { return localStorage.getItem(STORAGE_KEY) === '1'; }
    catch (e) { return false; }
  }
  function safeSetClosed() {
    try { localStorage.setItem(STORAGE_KEY, '1'); }
    catch (e) { /* private mode or disabled storage */ }
  }

  function buildWaLink(phone, message) {
    var clean = (phone || '').replace(/[^\d]/g, '');
    var url = 'https://wa.me/' + clean;
    if (message) url += '?text=' + encodeURIComponent(message);
    return url;
  }

  function initWidget(widget) {
    if (widget.dataset.dmInit === '1') return;
    widget.dataset.dmInit = '1';

    var btn        = widget.querySelector('[data-dm-toggle]');
    var box        = widget.querySelector('[data-dm-box]');
    var closeBtn   = widget.querySelector('[data-dm-close]');
    var ctaLink    = widget.querySelector('[data-dm-cta]');
    var badge      = widget.querySelector('[data-dm-badge]');
    var quickBtns  = widget.querySelectorAll('[data-dm-quick]');

    var phone       = widget.dataset.phone || '';
    var defaultMsg  = widget.dataset.defaultMessage || '';
    var autoOpen    = widget.dataset.autoOpen === 'true';
    var openDelay   = parseInt(widget.dataset.autoOpenDelay, 10) || 5;

    function setOpen(open) {
      widget.setAttribute('data-open', open ? 'true' : 'false');
      if (box) box.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    // CTA href
    if (ctaLink) ctaLink.setAttribute('href', buildWaLink(phone, defaultMsg));

    // Toggle button
    if (btn) {
      btn.addEventListener('click', function () {
        var willOpen = widget.getAttribute('data-open') !== 'true';
        setOpen(willOpen);
        if (willOpen && badge) badge.style.display = 'none';
      });
    }

    // Close button — also remembers in localStorage (no more auto-open)
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        setOpen(false);
        safeSetClosed();
      });
    }

    // Quick reply buttons → open WhatsApp directly with that message
    quickBtns.forEach(function (qb) {
      qb.addEventListener('click', function () {
        var message = qb.dataset.message || defaultMsg;
        window.open(buildWaLink(phone, message), '_blank', 'noopener,noreferrer');
      });
    });

    // Escape closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && widget.getAttribute('data-open') === 'true') {
        setOpen(false);
      }
    });

    // Auto-open
    if (autoOpen && !safeGetClosed()) {
      setTimeout(function () {
        // Only auto-open if not already manually opened in the meantime
        if (widget.getAttribute('data-open') !== 'true') {
          setOpen(true);
          if (badge) badge.style.display = 'none';
        }
      }, openDelay * 1000);
    }
  }

  function init() {
    var widgets = document.querySelectorAll('[data-dm-whatsapp]');
    widgets.forEach(initWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify theme editor section load (for live preview)
  document.addEventListener('shopify:section:load', function (e) {
    var w = e.target.querySelector ? e.target.querySelector('[data-dm-whatsapp]') : null;
    if (w) initWidget(w);
  });
})();
